import { orderBy } from 'lodash';
import { StatusEnum, UseLimitTypeEnum } from '../enum';
import { toFixed } from '../lib/utils';
import todayUsedCntMap from '../variable/todayUsedCntMap';
/**
 * 计算最优现金优惠券
 * @param opt
 */
export default function calBestCashCoupon(opt) {
    let { orderPrice, coupons } = opt;
    const { cashCouponMap } = opt;
    // 能叠加的,减的钱多的
    coupons = orderBy(coupons, ['isOverlying', 'discountValue', 'endTime'], ['desc', 'desc', 'asc']);
    let couponIsOverlying = true;
    for (const coupon of coupons) {
        let useLimitCnt = Infinity;
        if (coupon.useLimitType !== UseLimitTypeEnum.NoLimit) {
            useLimitCnt = (coupon.useLimitCnt || 0) - todayUsedCntMap.get(coupon.couponId);
        }
        if (!couponIsOverlying || orderPrice <= 0) {
            coupon.canUse = false;
            coupon.status = StatusEnum.Mutex;
        }
        else {
            if (useLimitCnt > 0) {
                if (!coupon.isOverlying) {
                    couponIsOverlying = coupon.isOverlying;
                }
                let cashCouponOff = coupon.discountValue;
                if (orderPrice < coupon.discountValue) {
                    cashCouponOff = orderPrice;
                }
                cashCouponMap[coupon.memberCouponId] = coupon;
                orderPrice = toFixed(orderPrice - cashCouponOff);
            }
            else {
                coupon.canUse = false;
                coupon.status = StatusEnum.Mutex;
            }
        }
    }
    return { cashCouponMap };
}
//# sourceMappingURL=calBestCashCoupon.js.map